export default __webpack_public_path__ + "static/media/RobertByirigiro.dcb97a32.png";